import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    fieldDisabled: translate({ id: 'order.form.bulk.loads.fieldDisabled.tooltip' }),
    removeAll: translate({ id: 'order.form.bulk.loads.removeAll' }),
    moreTooltip: translate({ id: 'order.form.bulk.loads.moreTooltip' }),
    deleteAllLoadsDisabledTooltip: translate({
      id: 'order.form.bulk.loads.deleteAllLoadsDisabledTooltip',
    }),
  }))

  return api
}
